import type { ChoirFunction, DocumentType, Member, MemberType, Voice } from '../types'

type Raw = [
  ime: string,
  priimek: string,
  type: MemberType,
  voice: Voice,
  functions: ChoirFunction[],
  prisoten: number,
  pricakovan: number,
  clanOd: string,
]

const raw: Raw[] = [
  ['Krištof', 'Strnad', 'aktivni', 'brez', ['dirigent'], 24, 24, '2009-09-01'],
  ['Dejan', 'Jerončič', 'aktivni', 'brez', ['korepetitor'], 21, 24, '2014-10-01'],
  ['Judita', 'Volčanšek', 'aktivni', 'sopran1', ['pevec', 'tajnik'], 22, 24, '2012-09-15'],
  ['Timotej', 'Siter', 'aktivni', 'bas1', ['pevec', 'predsednik'], 17, 23, '2010-09-01'],
  ['Barbara', 'Ganzitti Siter', 'aktivni', 'alt1', ['pevec', 'blagajnik'], 19, 24, '2011-02-01'],
  ['Alenka', 'Črnelič Kavčič', 'aktivni', 'sopran2', ['pevec', 'reditelj'], 14, 22, '2016-09-01'],
  ['Jurij', 'Žnideršič', 'aktivni', 'tenor1', ['pevec', 'umetniska'], 20, 23, '2013-09-01'],
  ['Jelka', 'Žnideršič', 'aktivni', 'alt2', ['pevec', 'disciplinska'], 5, 6, '2026-04-08'],
  ['Veronika', 'Strnad', 'gostujoci', 'sopran2', ['pevec', 'umetniska'], 6, 9, '2024-11-01'],
  ['Simona', 'Rožman Strnad', 'neaktivni', 'alt1', ['pevec', 'umetniska'], 0, 0, '2008-09-01'],

  // ——— pevski sestav (dejanski seznam zbora) ———
  ['Uroš', 'Brezovšek', 'aktivni', 'bas2', ['pevec', 'organizator'], 20, 24, '2012-09-01'],
  ['Benjamin', 'Ferk', 'aktivni', 'bas1', ['pevec'], 22, 24, '2015-09-01'],
  ['Maj', 'Medvešek', 'aktivni', 'tenor1', ['pevec'], 19, 24, '2018-09-01'],
  ['Ivanka', 'Črnelič Jurečič', 'aktivni', 'alt1', ['pevec', 'organizator'], 23, 24, '2009-09-01'],
  ['Maruša', 'Ferenčak', 'aktivni', 'sopran1', ['pevec'], 16, 23, '2021-09-01'],
  ['Katja', 'Plevnik', 'aktivni', 'sopran2', ['pevec'], 21, 24, '2016-09-01'],
  ['Lora Ana', 'Starič', 'aktivni', 'sopran1', ['pevec'], 18, 24, '2019-09-01'],
  ['Katarina', 'Petrič', 'aktivni', 'alt2', ['pevec'], 20, 24, '2014-09-01'],
  ['Aljaž', 'Arh', 'aktivni', 'bas2', ['pevec'], 17, 23, '2020-09-01'],
  ['Irena', 'Hribar', 'aktivni', 'alt1', ['pevec'], 22, 24, '2011-09-01'],
  ['Mateja', 'Jankovič Čurič', 'aktivni', 'alt2', ['pevec'], 19, 24, '2013-09-01'],
  ['Florijan', 'Volčanšek', 'aktivni', 'tenor2', ['pevec'], 23, 24, '2012-09-15'],
  ['Janž', 'Rener', 'aktivni', 'tenor1', ['pevec'], 15, 22, '2022-09-01'],
  ['Ana', 'Špiler', 'aktivni', 'sopran2', ['pevec'], 21, 24, '2017-09-01'],
  ['Janez', 'Balas', 'aktivni', 'bas1', ['pevec'], 14, 22, '2019-09-01'],
  ['Lana', 'Balas', 'aktivni', 'sopran1', ['pevec'], 13, 22, '2019-09-01'],
  ['Sabina', 'Žibert', 'aktivni', 'alt1', ['pevec'], 20, 24, '2015-09-01'],
  ['Karmen', 'Kukovičič', 'aktivni', 'alt2', ['pevec'], 18, 24, '2016-09-01'],
  ['Jasna', 'Polovič', 'aktivni', 'sopran2', ['pevec'], 22, 24, '2010-09-01'],
  ['Dean Jan', 'Petan', 'aktivni', 'bas2', ['pevec'], 16, 23, '2021-09-01'],
  ['Kaja', 'Strnad', 'aktivni', 'sopran1', ['pevec'], 21, 24, '2018-09-01'],
  ['Amir', 'Tokić', 'aktivni', 'tenor2', ['pevec'], 19, 24, '2017-09-01'],
  ['Robert', 'Rožman', 'aktivni', 'bas1', ['pevec'], 20, 24, '2013-09-01'],
  ['Neli', 'Bosina', 'aktivni', 'sopran2', ['pevec'], 12, 20, '2023-09-01'],
  ['Jani', 'Kolar', 'aktivni', 'tenor2', ['pevec'], 17, 24, '2016-09-01'],
  ['Barbara', 'Lipej', 'aktivni', 'alt1', ['pevec'], 18, 24, '2020-09-01'],
  ['Anja', 'Lipej', 'aktivni', 'sopran1', ['pevec'], 15, 23, '2021-09-01'],
  ['Veronika', 'Fabeković', 'aktivni', 'alt2', ['pevec'], 16, 24, '2019-09-01'],
  ['Ana', 'Žnideršič', 'aktivni', 'sopran2', ['pevec'], 20, 24, '2015-09-01'],
  ['Doroteja', 'Žinko', 'aktivni', 'alt1', ['pevec'], 14, 22, '2022-09-01'],
  ['Tinka', 'Hriberšek', 'aktivni', 'sopran1', ['pevec'], 21, 24, '2014-09-01'],
  ['Hana', 'Sambunjak', 'gostujoci', 'alt2', ['pevec'], 5, 8, '2025-10-01'],
  ['Lucija', 'Bosina', 'aktivni', 'sopran2', ['pevec'], 19, 24, '2018-09-01'],
  ['Maj', 'Mihelčič', 'aktivni', 'bas2', ['pevec'], 13, 21, '2023-09-01'],

  ['Nika', 'Jazbec', 'neaktivni', 'sopran1', ['pevec'], 0, 0, '2017-09-01'],
  ['Boštjan', 'Urek', 'nekdanji', 'tenor1', ['pevec'], 0, 0, '2007-09-01'],
  ['Ivan', 'Uršič', 'castni', 'bas2', ['pevec', 'umetniska'], 0, 0, '1994-09-01'],
]

const ulice = [
  'Cesta prvih borcev',
  'Trg izgnancev',
  'Bizeljska cesta',
  'Černelčeva cesta',
  'Trdinova ulica',
  'Šolska ulica',
  'Maistrova ulica',
  'Prešernova cesta',
]

const kraji: [string, string][] = [
  ['8250', 'Brežice'],
  ['8259', 'Bizeljsko'],
  ['8280', 'Brestanica'],
  ['8270', 'Krško'],
  ['8261', 'Jesenice na Dolenjskem'],
]

/** Člani z namerno nepopolnimi osebnimi podatki — za prikaz kontrole pred gostovanjem. */
const vrzeli: Record<string, ('datumRojstva' | 'dokumentTip' | 'dokumentStevilka' | 'prehrana' | 'naslov')[]> =
  {
    m04: ['dokumentStevilka'],
    m15: ['datumRojstva', 'dokumentTip', 'dokumentStevilka'],
    m25: ['dokumentStevilka'],
    m34: ['datumRojstva', 'dokumentStevilka'],
  }

/** Dejanske posebnosti pri prehrani iz seznama zbora. */
const prehranaPosebnosti: Record<string, string> = {
  m10: 'Brez glutena in mleka; od mesa le piščanec in riba',
  m20: 'Brez glutena',
  m31: 'Brez glutena, mlečnih izdelkov, svinjine in govedine',
  m32: 'Brez glutena, mleka in mlečnih izdelkov',
  m06: 'Vegetarijanska prehrana',
}

function slug(s: string): string {
  return s
    .toLowerCase()
    .replace(/č/g, 'c')
    .replace(/š/g, 's')
    .replace(/ž/g, 'z')
    .replace(/ć/g, 'c')
    .replace(/[^a-z]/g, '')
}

export const members: Member[] = raw.map(
  ([ime, priimek, type, voice, functions, prisoten, pricakovan, clanOd], i) => {
    const id = `m${String(i + 1).padStart(2, '0')}`
    const [posta, kraj] = kraji[i % kraji.length]
    const leto = 1958 + ((i * 7) % 44)
    const mesec = ((i * 5) % 12) + 1
    const dan = ((i * 11) % 27) + 1
    const dokTip: DocumentType = i % 7 === 0 ? 'potni_list' : 'osebna'
    const manjka = vrzeli[id] ?? []

    const clan: Member = {
      id,
      ime,
      priimek,
      type,
      voice,
      functions,
      email: `${slug(ime)}.${slug(priimek.split(' ')[0])}@mepz-viva.si`,
      telefon: `031 ${String(200 + i * 7).slice(0, 3)} ${String(400 + i * 13).slice(0, 3)}`,
      clanOd,
      naslov: `${ulice[i % ulice.length]} ${((i * 3) % 40) + 1}`,
      postnaStevilka: posta,
      posta: kraj,
      datumRojstva: `${leto}-${String(mesec).padStart(2, '0')}-${String(dan).padStart(2, '0')}`,
      dokumentTip: dokTip,
      dokumentStevilka: `${dokTip === 'potni_list' ? 'PB' : 'OI'}${String(1000000 + i * 7919).slice(0, 7)}`,
      prehrana: prehranaPosebnosti[id],
      prisoten,
      pricakovan,
      opomba:
        type === 'neaktivni'
          ? 'Začasno neaktivna zaradi družinskih obveznosti. Vrnitev predvidoma jeseni 2027.'
          : type === 'castni'
            ? 'Častni član zbora, soustanovitelj. Vabljen na vse slovesne dogodke.'
            : undefined,
    }

    manjka.forEach((polje) => {
      delete clan[polje]
    })

    return clan
  },
)

export const byId = (id: string): Member | undefined => members.find((m) => m.id === id)

/** Poišče člana po imenu in priimku — uporabno pri vnosu mock podatkov. */
export function idOf(ime: string, priimek: string): string {
  const found = members.find((m) => m.ime === ime && m.priimek === priimek)
  if (!found) throw new Error(`Član ${ime} ${priimek} ne obstaja.`)
  return found.id
}

/** Demo profiles used on the login screen. */
export const DEMO_CLAN = 'm03' // Judita Volčanšek
export const DEMO_GOST = 'm09' // Veronika Strnad
export const DEMO_ADMIN = 'm01' // Krištof Strnad
